.selection-marquee {
    position: absolute;
    border: 2px solid rgba(66, 133, 244, 0.8);
    background-color: rgba(66, 133, 244, 0.1);
    pointer-events: none; // sin interacción, solo visual
    display: none; // oculto por defecto
    z-index: 1000; // encima de todo
    border-radius: 5px;
}